var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_744_40653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0007 18.6666C22.3425 18.6666 22.6243 18.924 22.6628 19.2556L22.6673 19.3333V20.6666C22.6673 21.7318 21.8347 22.6024 20.7848 22.6633L20.6673 22.6666H11.334C10.2689 22.6666 9.39821 21.834 9.33738 20.7842L9.33398 20.6666V19.3333C9.33398 18.9651 9.63246 18.6666 10.0007 18.6666C10.3425 18.6666 10.6243 18.924 10.6628 19.2556L10.6673 19.3333V20.6666C10.6673 21.0085 10.9247 21.2903 11.2562 21.3288L11.334 21.3333H20.6673C21.0092 21.3333 21.291 21.076 21.3295 20.7444L21.334 20.6666V19.3333C21.334 18.9651 21.6325 18.6666 22.0007 18.6666ZM16.0007 9.33331C16.3688 9.33331 16.6673 9.63179 16.6673 9.99998V16.39L17.5292 15.5286C17.7696 15.2883 18.1477 15.2698 18.4093 15.4731L18.4721 15.5286C18.7124 15.7689 18.7309 16.1471 18.5275 16.4086L18.4721 16.4714L16.4721 18.4714L16.4427 18.499L16.3975 18.5358L16.3234 18.5835L16.2482 18.6192L16.178 18.6427L16.079 18.6621L16.0007 18.6666L15.9505 18.6648L15.8668 18.6532L15.7926 18.6335L15.7185 18.6042L15.6535 18.5693L15.5895 18.5248C15.5683 18.5082 15.5482 18.4904 15.5292 18.4714L13.5292 16.4714C13.2689 16.211 13.2689 15.7889 13.5292 15.5286C13.7696 15.2883 14.1477 15.2698 14.4093 15.4731L14.4721 15.5286L15.334 16.39V9.99998C15.334 9.63179 15.6325 9.33331 16.0007 9.33331Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_744_40653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8H24V24H8V8Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.7f16eb3f.svg";
export { ForwardRef as ReactComponent };